import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useController } from 'react-hook-form';

export const SPECIAL_OCCASION_OPTIONS = ['None', 'Birthday', 'Anniversary'];

function SpecialOccasionFormField() {
  const {
    field: { onChange, name, value, ref, onBlur }
  } = useController({
    name: 'specialOccasion'
  });

  return (
    <FormControl
      fullWidth
      sx={theme => ({
        '& .Mui-focused': { color: theme.typography.body1 }
      })}
    >
      <InputLabel id="special-occasion">Special Occasion</InputLabel>
      <Select
        labelId="special-occasion"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        label="Special Occasion"
        inputRef={ref}
        MenuProps={{
          MenuListProps: {
            sx: theme => ({
              background: theme.palette.background.default,
              borderColor: theme.typography.body1,
              borderRadius: '4px',
              border: '2px solid'
            })
          }
        }}
        IconComponent={KeyboardArrowDownIcon}
        sx={theme => ({
          color: theme.typography.body1,
          '.MuiSvgIcon-root': {
            fill: theme.typography.body1.color
          }
        })}
      >
        {SPECIAL_OCCASION_OPTIONS.map(option => (
          <MenuItem value={option} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SpecialOccasionFormField;
